import CustSat from './CustSat';

export default CustSat;
